import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * Holcim Brand PrimeNG Theme Preset
 * Replaces the default Emerald palette with Holcim Primary Blue (#1D4370)
 * so all PrimeNG fields (inputs, dropdowns, multiselect, datepicker,
 * checkboxes, radiobuttons, switches, tabs, trees, etc.) use blue
 * for their active, selected, checked, and focused states in both Light and Dark modes.
 */
export const HolcimTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f0f5fa',
      100: '#e6f2f7',
      200: '#c2dded',
      300: '#93c1de',
      400: '#5ea0cc',
      500: '#1D4370',
      600: '#18375c',
      700: '#153255',
      800: '#0e223a',
      900: '#081525',
      950: '#040b13'
    },
    colorScheme: {
      light: {
        formField: {
          focusBorderColor: '{primary.500}'
        },
        highlight: {
          background: '{primary.100}',
          focusBackground: '#d4e8f3',
          color: '{primary.500}',
          focusColor: '{primary.700}'
        }
      },
      dark: {
        formField: {
          focusBorderColor: '{primary.400}'
        },
        highlight: {
          background: 'rgba(29, 67, 112, 0.45)',
          focusBackground: 'rgba(29, 67, 112, 0.65)',
          color: '#ffffff',
          focusColor: '#ffffff'
        }
      }
    },
    focusRing: {
      width: '2px',
      style: 'solid',
      color: 'rgba(29, 67, 112, 0.25)',
      offset: '2px'
    }
  }
});
